module.exports = {
  'Loading...': '加载中...',
}



// WEBPACK FOOTER //
// ./src/components/UI/Loading/CN.js